module.exports = __webpack_public_path__ + "img/web4.a8d3d607.png";